export const LAYOUT = {
    STICKY_TOOLBAR: 'sticky-toolbar',
};
